import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/classPrivateFieldLooseKey";
import { getInterpolation, mergeTranslations } from "./utils";
var _translations = /*#__PURE__*/_classPrivateFieldLooseKey("translations");
var _language = /*#__PURE__*/_classPrivateFieldLooseKey("language");
var _namespace = /*#__PURE__*/_classPrivateFieldLooseKey("namespace");
var _fallbackLanguages = /*#__PURE__*/_classPrivateFieldLooseKey("fallbackLanguages");
var _fallbackNamespaces = /*#__PURE__*/_classPrivateFieldLooseKey("fallbackNamespaces");
var _insertedBundles = /*#__PURE__*/_classPrivateFieldLooseKey("insertedBundles");
var _getNamespaces = /*#__PURE__*/_classPrivateFieldLooseKey("getNamespaces");
var _getLocales = /*#__PURE__*/_classPrivateFieldLooseKey("getLocales");
export var CrehanaI18n = /*#__PURE__*/function () {
  function CrehanaI18n(params) {
    _classCallCheck(this, CrehanaI18n);
    Object.defineProperty(this, _getLocales, {
      value: _getLocales2
    });
    Object.defineProperty(this, _getNamespaces, {
      value: _getNamespaces2
    });
    Object.defineProperty(this, _translations, {
      writable: true,
      value: {}
    });
    Object.defineProperty(this, _language, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _namespace, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _fallbackLanguages, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _fallbackNamespaces, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _insertedBundles, {
      writable: true,
      value: new WeakSet()
    });
    _classPrivateFieldLooseBase(this, _language)[_language] = params.language;
    _classPrivateFieldLooseBase(this, _namespace)[_namespace] = params.namespace;
    if (params.translations) {
      _classPrivateFieldLooseBase(this, _translations)[_translations] = params.translations;
    }
  }
  return _createClass(CrehanaI18n, [{
    key: "setLanguage",
    value: function setLanguage(language) {
      _classPrivateFieldLooseBase(this, _language)[_language] = language;
    }
  }, {
    key: "setNamespace",
    value: function setNamespace(namespace) {
      _classPrivateFieldLooseBase(this, _namespace)[_namespace] = namespace;
    }
  }, {
    key: "setFallbackLanguages",
    value: function setFallbackLanguages(languages) {
      _classPrivateFieldLooseBase(this, _fallbackLanguages)[_fallbackLanguages] = languages;
    }
  }, {
    key: "setFallbackNamespaces",
    value: function setFallbackNamespaces(namespaces) {
      _classPrivateFieldLooseBase(this, _fallbackNamespaces)[_fallbackNamespaces] = namespaces;
    }
  }, {
    key: "t",
    value: function t(key, config) {
      var _ref = config || {},
        defaultValue = _ref.defaultValue,
        interpolation = _ref.interpolation,
        namespace = _ref.namespace;
      var locales = _classPrivateFieldLooseBase(this, _getLocales)[_getLocales](namespace);
      var count = typeof (interpolation === null || interpolation === void 0 ? void 0 : interpolation.count) === 'number' ? interpolation.count : config === null || config === void 0 ? void 0 : config.count;
      if (locales) {
        var replacements;
        var foundLocale = locales[key];
        if (count) {
          replacements = {
            count: count
          };
          if (count > 1) {
            var pluralKey = "".concat(key, "_plural");
            if (locales[pluralKey]) {
              foundLocale = locales[pluralKey];
            }
          }
        }
        var locale = foundLocale || defaultValue;
        if ((replacements || interpolation) && locale) {
          return getInterpolation(locale, _objectSpread(_objectSpread({}, replacements), interpolation));
        }
        return locale || key;
      }
      return defaultValue || key;
    }

    /**
     * Insert a new translation bundle
     * @returns `true` if is a new bundle, `false` if it was already inserted
     */
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(bundle) {
      if (_classPrivateFieldLooseBase(this, _insertedBundles)[_insertedBundles].has(bundle)) return false;
      _classPrivateFieldLooseBase(this, _insertedBundles)[_insertedBundles].add(bundle);
      _classPrivateFieldLooseBase(this, _translations)[_translations] = mergeTranslations(_classPrivateFieldLooseBase(this, _translations)[_translations], bundle);
      return true;
    }
  }]);
}();
function _getNamespaces2() {
  var foundNamespace = _classPrivateFieldLooseBase(this, _translations)[_translations][_classPrivateFieldLooseBase(this, _language)[_language]];
  if (foundNamespace) {
    return foundNamespace;
  }
  if (_classPrivateFieldLooseBase(this, _fallbackLanguages)[_fallbackLanguages]) {
    for (var i = 0; i < _classPrivateFieldLooseBase(this, _fallbackLanguages)[_fallbackLanguages].length; i++) {
      var language = _classPrivateFieldLooseBase(this, _fallbackLanguages)[_fallbackLanguages][i];
      if (language) {
        var foundFallbackNamespace = _classPrivateFieldLooseBase(this, _translations)[_translations][language];
        if (foundFallbackNamespace) {
          return foundFallbackNamespace;
        }
      }
    }
  }
}
function _getLocales2(customNamespace) {
  var namespaces = _classPrivateFieldLooseBase(this, _getNamespaces)[_getNamespaces]();
  if (!namespaces) return;
  var ns = customNamespace || _classPrivateFieldLooseBase(this, _namespace)[_namespace];
  if (ns) {
    var foundLocales = namespaces[ns];
    if (foundLocales) {
      return foundLocales;
    }
  }
  if (_classPrivateFieldLooseBase(this, _fallbackNamespaces)[_fallbackNamespaces]) {
    for (var i = 0; i < _classPrivateFieldLooseBase(this, _fallbackNamespaces)[_fallbackNamespaces].length; i++) {
      var namespace = _classPrivateFieldLooseBase(this, _fallbackNamespaces)[_fallbackNamespaces][i];
      if (namespace) {
        var foundFallbackLocales = namespaces[namespace];
        if (foundFallbackLocales) {
          return foundFallbackLocales;
        }
      }
    }
  }
}
export default CrehanaI18n;